// extracted by mini-css-extract-plugin
export default {"container":"SizeInput_container__-M9GF"};